<template>
  <div class="roundBg">

    <h1 class="title-round is-size-2" style="padding-top: 0px;">
      <span v-if="round.type === 'Finals'  && gameType === GameType.TOURNAMENT">
          FINALS {{ round.title }}
          </span>
      <span v-else>
            {{ round.title }}
      </span>
    </h1>
    
    <div class="in_game_user_management" v-if="showPlayerManagement && (gameType === GameType.ROUNDROBIN || gameType === GameType.TOURNAMENT) && (round.id == this.$parent.nextRoundNumber || round.id == 1 && this.$parent.nextRoundNumber == 0)">
      <div class="container">
        <div v-if="showPlayerManagementPlayerOptions" class="has-background-black" style="padding: 10px;">
          <h3 class="is-size-3 has-text-white">Player Management:</h3>
          <div class="box has-background-dark">
            <div class="columns">
              <div class="column">
                <div v-for="(player) in this.$parent.gameData.players" :player="player" :key="player.player">
                  <div v-if="!player.editable" class="is-text-4 has-text-white">
                    <div class="columns">
                      <div class="column">
                      </div>
                      <div class="column">
                        <i class="fas fa-user"></i>
                        <span>
                            {{ player.given_name || player.name}} 
                        </span>
                      </div>
                      <div class="column">
                      </div>
                      <div class="column">
                        <a class="button is-danger" v-on:click="removeInGamePlayer(player)">Remove</a>
                      </div>
                    </div>
                  </div>
                  <div v-if="player.editable">

                    <div class="columns">
                      <div class="column">
                      </div>
                      <div class="column">
                          <span>
                              <input class="input" style="width: 90%;" type="text" v-model="player.name" placeholder="Name"/> 
                          </span>
                      </div>
                      <div class="column">
                          <input class="input" type="text" v-model="player.email" placeholder="Email"/> 
                      </div>
                      <div class="column">
                        <a class="button is-info" v-on:click="saveInGamePlayer(player)">Save</a>&nbsp;
                        <a class="button is-warning" v-on:click="cancelInGamePlayer(player)">Cancel</a>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
          <div style="margin: 20px;" v-if="this.$parent.gameData.players.length < 21">
              <a class = "button is-info" v-on:click="addInGamePlayer">Add a player...</a>
          </div>
        </div>
        <div class="has-background-info" style="border: solid yellow 1px; padding: 10px;">
            <a class="button is-danger" style="margin-right: 10px;" v-on:click="showPlayerManagementPlayerOptionsToggle();">Players</a>
            <a class="button is-primary" style="margin-right: 10px;" v-on:click="openNextRound(round.id,1);">Start round</a>
            <a class="button is-warning" v-on:click="skipToFinals(round);">Skip to Finals</a>
        </div>
      </div>
    </div>

    <div v-for="(match, index) in round.matches" :match="match" :gameType="gameType" :key="index" class="is-marginless match-box">
        <div :key="$parent.componentKey">
          <h1 class="title is-size-4" v-on:click="toggleMatch(round.id,(index+1),match.type, gameType, match.uniqueId)">
            <i v-if="match.display" class="fas fa-chevron-circle-down expand-icon"></i>
            <i v-if="!match.display" class="fas fa-chevron-circle-right expand-icon"></i>
            Match {{ (index+1) }}
            <!--<span v-if="gameType === GameType.ROUNDROBIN && round.type === 'Finals'"> {{ match.title }} </span>-->
            <span v-if="match.completed && (gameType === GameType.ROUNDROBIN || gameType === GameType.TOURNAMENT)">
              <span>
                <a @click="markUncompleted(match)">
                  <i class="fas fa-lock locked"></i>
                </a>
              </span>
            </span>
            <span v-if="match.completed == false && (gameType === GameType.ROUNDROBIN || gameType === GameType.TOURNAMENT)">
              <span class="incomplete">
                <i class="fas fa-exclamation"></i> <span class="incomplete-text">incomplete</span>
              </span>
            </span>
          </h1>
        </div>

        <div v-if="match.display" :key="$parent.componentKey+1">
          <Match :match="match" :gameType="gameType" />
        </div>
        <div v-if="!match.display" :key="$parent.componentKey+2">
          <div class="winner-container">
            <div v-if="gameType === GameType.SOLO && match.completed === true">
              <h1 class="is-size-4">Total: {{ getSoloThrowsTotal(match) }}</h1>
            </div>
            <div v-if="gameType === GameType.SOLO && match.completed === false">
              <span>(incomplete match)</span>
            </div>
            <div v-if="gameType === GameType.ROUNDROBIN">
              <div v-if="
                (gameType === GameType.ROUNDROBIN && match.completed === true
                && match.id.indexOf('Finals') != -1 && (match.matchPlayers[0].bye === true && match.matchPlayers[1].bye === true))
                ">
                <h1 class="is-size-4"><span class="winner-name">(bye)</span></h1>
              </div>
              <div v-if="
                (gameType === GameType.ROUNDROBIN && match.completed === true 
                && match.id.indexOf('Finals') != -1 && ((match.matchPlayers[0].bye === true && match.matchPlayers[1].bye === false) 
                || (match.matchPlayers[0].bye === false && match.matchPlayers[1].bye === true)))
                ">
                <h1 class="is-size-4"><i class="fas fa-award winner"></i> <span class="winner-name">{{ getWinner(match) }} </span></h1>
              </div>
              <div v-if="
                (gameType === GameType.ROUNDROBIN && match.completed === true && 
                match.id.indexOf('Finals') != -1 && (match.matchPlayers[0].bye === false && match.matchPlayers[1].bye === false))
                ">
                <h1 class="is-size-4"><i class="fas fa-award winner"></i> <span class="winner-name">{{ getWinner(match) }} </span></h1>
                <h1 class="is-size-4"><i class="fas fa-award loser"></i> <span class="winner-name">{{ getLoser(match) }} </span></h1>
              </div>
              <div v-if="
                (gameType === GameType.ROUNDROBIN && match.completed === true && 
                match.id.indexOf('Finals') === -1)
                ">
                <h1 class="is-size-4"><i class="fas fa-award winner"></i> <span class="winner-name">{{ getWinner(match) }} </span></h1>
                <h1 class="is-size-4"><i class="fas fa-award loser"></i> <span class="winner-name">{{ getLoser(match) }} </span></h1>
              </div>
              <div v-if="gameType === GameType.ROUNDROBIN && match.completed === false">
                <div>
                  <div class="players">
                    <RoundPlayers :players="match.matchPlayers"/>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="gameType === GameType.TOURNAMENT && match.completed === true">
              <div class="players">
                <h1 class="is-size-4"><i class="fas fa-award winner"></i> <span class="winner-name">{{ getTournamentMatchWinner(match) }} </span></h1>
              </div>
            </div>
            <div v-if="gameType === GameType.TOURNAMENT && match.completed === false">
              <div>
                <RoundPlayers :players="match.matchPlayers"/>
                <!--
                <div class="players" v-for="player in match.matchPlayers" :key="player.id">
                  <h1 class="is-size-5"><i class="fas fa-user"></i> <span class="player-name">{{ getPlayerName(match,player.id) }} </span></h1>
                </div>
                -->
              </div>
            </div>
            
          </div>
        </div>
    </div>
    <div v-if="(gameType === GameType.ROUNDROBIN) && round.type === 'Finals'">
      <div v-for="match in matchesRemaining" :key="match.Match">
        <!-- these need to be enabled to jump ahead? -->
        <MatchEmpty :match="match"/>
      </div>
    </div>

  </div>
</template>

<script>
import Match from '@/components/Match';
import RoundPlayers from '@/components/RoundPlayers';
import MatchEmpty from '@/components/MatchEmpty';
import {v4 as uuidv4} from 'uuid';
import { GameType } from '@/enum/gameType.js';

export default {
  props: [
    'round', 
    'gameType'
  ],
    components : {
      Match,
      MatchEmpty,
      RoundPlayers
  },
  data () {
    return {
      GameType,
      showPlayerManagementPlayerOptions: false,
      playersEdited: true
    }
  },  
  computed: {
    showPlayerManagement: function () {
      return this.$parent.showPlayerManagement;
    },
    matchesRemaining() {
      var finalsSchema = this.$parent.getFinalSchemaRounds();
      var rndArr = this.round.id.split("_");
      var rndNum = parseInt(rndArr[0]);
      var currentRound = this.round;
      var currentMatches = currentRound.matches;
      var mtchs = []; 
      var currentMatches = (currentRound != null ? currentRound.matches : []);
      var schemaRound = finalsSchema.Rounds[rndNum-1];
      var schemaMatches = (schemaRound != null ? schemaRound.Matches : []);
      
      if (currentMatches != null && schemaMatches != null) {
        for(var x = currentMatches.length; x < schemaMatches.length; x++) {
          var mtch = schemaMatches[x];
          mtchs.push(mtch);
        }
      }
      return mtchs;
    }
  },
  methods:{
    showPlayerManagementPlayerOptionsToggle() {
      this.showPlayerManagementPlayerOptions = !this.showPlayerManagementPlayerOptions;
    },
    skipToFinals(round) {
      return this.$parent.skipToFinals(round);
    },
    openNextRound(round_number, match_number) {

      //TODO tournament next step
      //have the players changed?
      if (this.$parent.gameData.gameType === GameType.TOURNAMENT) {
        //alert("OK, begin next round: " + round_number);
        this.showHidePlayerManagement();

        this.$parent.openNextRound(round_number, match_number);

        this.$parent.saveGameInProgress(GameType.TOURNAMENT)

      } else if (this.playersEdited && this.$parent.gameData.gameType === GameType.ROUNDROBIN) {

        //alert("OK, begin next round: " + round_number);
        this.showHidePlayerManagement();

        //alert("update players")
        
        //TODO why are we rbuilding?  we should be checking if the players have changed.
        if (this.$parent.validatePlayers()) {

          //remove remaining rounds
          //console.log("-----removing remaining rounds");
          this.$parent.gameData.rounds.splice(round_number-1, (this.$parent.gameData.rounds.length+1) - round_number);

          //get the new schema
          var numRounds = this.$parent.rounds;
          var numThrows = this.$parent.throws;
          var numPlayers = this.$parent.gameData.players.length;

          //console.log("-----generating remaining rounds");
          var new_rounds = this.$parent.generateRoundRobinRounds(numRounds, numThrows, numPlayers, round_number);

          for(var i = 0; i < new_rounds.length; i++) {
            //console.log("----adding round: " + new_rounds[i].id);
            this.$parent.gameData.rounds.push(new_rounds[i]);
          }
        }
        this.toggleMatch(round_number, match_number, "", this.gameType, "");

        var match = this.$parent.getMatch(round_number, match_number, this.gameType);
        var m = {
          uniqueItemId: match.uniqueId,
          uniqueId: this.$parent.gameData.uniqueId,
          match: match,
          title: this.$parent.gameData.title,
          league: this.$parent.gameData.league,
          lane_id: (this.$parent.gameData?.lane_id ? this.getFirstAndLastUppercase(this.$parent.gameData.lane_id) : "")
        }
        this.$parent.sendBroadcastControlMessage('match', m, 'New Match','openNextRound');

        this.$parent.saveGameInProgress(GameType.TOURNAMENT)

      } else {
        this.toggleMatch(round_number, match_number, "", this.gameType, "");
      }
    },
    getFirstAndLastUppercase: function(str) {
      if (str.length < 2) {
        return str.toUpperCase(); // If the string is too short, just return it in uppercase
      }
      const firstLetter = str.charAt(0).toUpperCase();
      const lastLetter = str.charAt(str.length - 1).toUpperCase();
      return firstLetter + lastLetter;
    },        
    showHidePlayerManagement() {
      //alert(this.showPlayerManagement);
      this.$parent.showPlayerManagement = !this.$parent.showPlayerManagement;
    },
    addInGamePlayer() {
      //alert("add");
      var player_uuid = uuidv4();

      //id, nickname, name, given_name, family_name, email, picture
      var p = new this.$playerClass(player_uuid, "", "", "", "", "", "", true);

      //console.log(p);
      //alert(p);
      this.$parent.gameData.players.push(p);
    },
    saveInGamePlayer(player) {
      //add player to players list.
      //console.log("adding new player...");
      //console.log(player);
      this.$parent.playersModified = true;
      player.editable = false;
      //this.$parent.gameData.players.push(player);
    },
    cancelInGamePlayer(player) {
      //if (confirm("Cancel adding new player?")) {
        //console.log(player);
        //alert("cancel!");
        this.$parent.gameData.players.pop();
      //}
    },
    removeInGamePlayer(player) {
      //console.log("removing player...");
      //console.log(player);
      this.$parent.playersModified = true;

      var pos = this.$parent.gameData.players.map(function(e) { return e.id; }).indexOf(player.id);

      this.$parent.gameData.players.splice(pos, 1);
    },
    markUncompleted(match) {
      match.completed = false;
      match.display = true;
    },
    getSoloThrowsTotal(match) {
      var p = match.matchPlayers[0];
      var total = 0;
      p.throws.forEach(t => {
        total += t.basicScore;
      });
      return total;
    },
    savePlayerName(player) {
      //console.log("player", player);
      if (player.player.name != "") {
        this.$parent.gameData.players.forEach(p =>{
          //alert("player.id: " + player.id + ", p.id: " + p.id);
          if (p.id == player.id) {
            //alert("player.name: " + player.name);
            p.name = player.player.name;
            player.edit = false;
          }
        });
        
        if (this.gameType === GameType.TOURNAMENT) {
          console.log("player", player);
          this.$parent.gameData.sets.forEach(s => {
            s.rounds.forEach(r => {
              r.matches.forEach(m => {
                m.matchPlayers.forEach(p => {
                  if (p.player.id == player.player.id) {
                    p.player.name = player.player.name;
                  }
                })
              })
            })
          })
        }
        
      }
    },
    editPlayerName(player) {
      //alert("edit player");
      this.round.matches.forEach(m => {
        //alert("match");
        m.matchPlayers.forEach(p => {
          //alert("player");
          if (p.id == player.id) {
            p.edit = true;
            //alert("edit set to true");
          }
        })
      })
    },
    getPlayerName(match, playerNum) {
      var bye = match.matchPlayers[playerNum-1].bye;
      return match.matchPlayers[playerNum-1].player.name + (bye? " (bye)" : "");
    },
    /*
    getMatchPlayer(match, playerNum) {
      return match.matchPlayers[playerNum-1].player;
    },
    */
    getTournamentMatchWinner(match) {
      var list = [];
      //console.log("getTournamentMatchWinner", match);
      
      for (var x = 0; x < match.matchPlayers.length; x++) {
        var matchPlayer = match.matchPlayers[x];
        var name = matchPlayer.player.name;

        var pts = 0;
        matchPlayer.throws.forEach(t => {
          pts += t.basicScore;
        })
        name += " Total: " + pts;
        list.push({ "name" : name, "total" : pts });
      }
      
      list = list.sort((a, b) => b.total - a.total);

      //console.log("list", list);
      var winner = list[0];
      //
      //
      //console.log("winner", winner.name);
      return winner.name;
    },
    getWinner(match) {
      var name = "";
      if (match.winnerId != null) {

        var isBye = false;
        for (var x = 0; x < match.matchPlayers.length; x++) {
          var matchPlayer = match.matchPlayers[x];
          if (matchPlayer.bye) isBye = true;
        }

        for (var x = 0; x < match.matchPlayers.length; x++) {
          var matchPlayer = match.matchPlayers[x];
          if (match.winnerId === matchPlayer.id) {
            name = matchPlayer.player.name;

            var pts = 0;
            matchPlayer.throws.forEach(t => {
              pts += t.basicScore;
            })
            if (pts > 0) name += " Total: " + pts;
            if (matchPlayer.bye === true) {
              name += " (bye)";
            }
          }
        }
        return name;
      }
    },
    getLoser(match) {
      var name = "";
      if (match.winnerId != null) {
        match.matchPlayers.forEach(matchPlayer => {
          if (match.winnerId !== matchPlayer.id) {
            name = matchPlayer.player.name;

            var pts = 0;
            matchPlayer.throws.forEach(t => {
              pts += t.basicScore;
            })
            if (pts > 0) name += " Total: " + pts;
            if (matchPlayer.bye === true) {
              name += " (bye)";
            }
          }
        });
        return name;
      }
    },
    lockFinals(match) {
      //console.log("Round: lockFinals");
      this.$parent.lockFinals();
    },
    openNextMatch(match) {
      //console.log("Round: openNextMatch");
      this.$parent.openNextMatch(match);
    },
    hasNextMatch(match) {
      return this.$parent.hasNextMatch(match);
    },
    getCountFinalPlayers() {
      return this.$parent.getCountFinalPlayers();
    },
    areFinalsCompleted() {
      //console.log("Round->areFinalsCompleted?");
      return this.$parent.areFinalsCompleted();
    },
    toggleMatch(roundId, matchId, matchType, gameType, uniqueId) {
      //console.log("toggle match - roundId: " + roundId + ", matchId: " + matchId + ", matchType: " + matchType + ", gameType: " + gameType + ", uniqueId: " + uniqueId);
      this.$parent.toggleMatch(roundId, matchId, matchType, gameType, uniqueId);
    },
    /*
    displayMatch(roundId, matchId) {
      //console.log("display match - roundId: " + roundId + ", matchId: " + matchId);
      this.$parent.displayMatch(roundId, matchId);
    }
    */
  }
}
</script>

<style lang="scss" scoped>
  .in_game_user_management {
    border: solid yellow 1px;
    margin-bottom: 10px;
  }
  .incomplete {
    color: rgb(255, 255, 125) !important;
    padding-left: 30px;
  }
  .incomplete-text {
    font-size: 0.50m;
    font-weight: normal;
  }
  .locked {
    color: yellow;
  }
  .locked-finals {
    color: yellow;
  }
  h1 {
    color: rgb(255, 255, 125) !important;
  }
  .players {
    color: yellow;
  }
  .winner {
    color: gold;
  }
  .loser {
    color: gray;
  }
  .winner-name {
    color: green;
  }
  .winner-container {
    padding: 20px;
    background-color: rgb(36, 36, 39);
  }
  .expand-icon {
    color: yellow;
  }
  .match-box {
    border: solid yellow 1px;
    border-radius: 5px !important;
    margin-bottom: 10px !important;
  }
  .title {
    border-bottom: solid yellow 1px;
    font-family: '28 Days Later';
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    color: green !important;
    cursor: pointer;
    margin-bottom: 0px;
    background-color: rgb(36, 36, 39);
  }
  .title-round {
    font-family: '28 Days Later';
    padding-left: 20px;
    padding-top: 20px;
    color: red !important;
  }
  .roundBg {
    padding-left: 0px;
    padding-right: 0px;
  }
</style>